import { Outlet } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import { Footer } from "@/components/ui/footer";
import { Toaster } from "sonner";
import { SubscriptionProvider } from "@/context/SubscriptionContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { ApiErrorModal } from "@/components/ui/ApiErrorModal";
import ScrollToTop from "@/components/ScrollToTop";
import ErrorBoundary from "@/components/ui/ErrorBoundary";

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

if (!PUBLISHABLE_KEY) {
  throw new Error("Missing Publishable Key");
}

export default function RootLayout() {
  const navigate = useNavigate();

  return (
    <ClerkProvider navigate={navigate} publishableKey={PUBLISHABLE_KEY}>
      <ScrollToTop />
      <ThemeProvider>
      <SubscriptionProvider>
        <main className="flex flex-col min-h-screen">
          <div className="flex-grow">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </div>
          <Footer />
        </main>
        <Toaster position="bottom-right" richColors />
        <ApiErrorModal />
      </SubscriptionProvider>
      </ThemeProvider>
    </ClerkProvider>
  );
}
